import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";
//import "./LiveInstagramFeed.css"; // Import custom CSS

const INSTAGRAM_ACCESS_TOKEN =
  "IGAAMfdZBapi1dBZAGI0UDRHNkp2cXRXOVlKdG9ybjhIR3I4RG9lc0lXWkdObjcya2M4YUV5OWR5RXJEWTViMTR6N3ZA5b2sxVURtZAXlEUTQxTWJoZAkZATYklDY2cteWJkWWhnTlo3Y0ZAudS1zWjFGWl9qVDZAUYnI4Y3otczBDdzQyWQZDZD";

const LiveInstagramFeed = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchInstagramPosts = async () => {
      try {
        const response = await axios.get(
          `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink&access_token=${INSTAGRAM_ACCESS_TOKEN}`
        );

        const filteredPosts = response.data.data.filter(
          (post) =>
            post.media_type === "IMAGE" || post.media_type === "CAROUSEL_ALBUM"
        );

        setPosts(filteredPosts);
      } catch (error) {
        console.error("Error fetching Instagram feed:", error);
      }
    };

    fetchInstagramPosts();
  }, []);

  return (
    <div className="instagram-feed-container">
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={10}
        slidesPerView={5}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        breakpoints={{
          640: { slidesPerView: 2 }, // Mobile: 1 item per slide
          768: { slidesPerView: 3 }, // Tablet: 2 items per slide
          1024: { slidesPerView: 5 }, // Desktop: 3 items per slide
        }}
        className="instagram-swiper"
      >
        {posts.length > 0 ? (
          posts.map((post) => (
            <SwiperSlide key={post.id} className="instagram-slide">
              <a
                href={post.permalink}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={post.media_url}
                  alt={post.caption || "Instagram Post"}
                  className="instagram-image"
                />
              </a>
            </SwiperSlide>
          ))
        ) : (
          <p className="loading-text">Loading Instagram feed...</p>
        )}
      </Swiper>
    </div>
  );
};

export default LiveInstagramFeed;
